module.exports = __webpack_public_path__ + "img/icon-games-black.713ee03c.svg";